import React, { lazy } from 'react';
function GoldenParticles() {
  const particles = Array.from({
    length: 8
  });
  return <div className="absolute inset-0 overflow-hidden pointer-events-none z-[2] hidden sm:block" data-id="element-260">
      {particles.map((_, i) => {
      const left = `${Math.random() * 100}%`;
      const delay = `${Math.random() * 5}s`;
      const duration = `${8 + Math.random() * 7}s`;
      const size = Math.random() > 0.5 ? 'w-1 h-1' : 'w-1.5 h-1.5';
      return <div key={i} className={`absolute bottom-0 rounded-full bg-gold/60 ${size}`} style={{
        left,
        animation: `particleFloat ${duration} linear ${delay} infinite`
      }} data-id="element-261" />;
    })}
    </div>;
}
export function HeroSection() {
  return <section className="relative px-4 sm:px-[5%] py-16 sm:py-24 flex flex-col items-center text-center overflow-hidden min-h-[75vh] sm:min-h-[85vh] justify-center" role="banner" data-id="element-262">
      <img src="https://cdn.shopify.com/s/files/1/0981/0781/8286/files/Simbolo_dorado_infinito_en_el_vacio_06918f45-889b-4991-b0b4-6e1b82309461.png?v=1777332793" alt="" aria-hidden="true" loading="eager" decoding="async" fetchPriority="high" sizes="100vw" width="1920" height="1080" className="absolute inset-0 w-full h-full object-cover object-[center_20%] sm:object-center opacity-35 z-0 pointer-events-none" data-id="element-263" />

      <div className="absolute inset-0 bg-gradient-to-b from-[#0A0A0B] via-transparent to-[#0A0A0B] z-[1]" aria-hidden="true" data-id="element-264" />

      <GoldenParticles data-id="element-265" />

      <div className="relative z-10 max-w-4xl animate-fadeInUp flex flex-col items-center gap-0" data-id="element-266">
        <div className="relative w-full flex justify-center mb-6 sm:mb-10" data-id="element-267">
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[300px] sm:w-[600px] h-[150px] sm:h-[200px] bg-[radial-gradient(ellipse_at_center,rgba(212,175,55,0.15),transparent_70%)] blur-3xl z-[5] pointer-events-none" style={{
          animation: 'pulseGlow 4s ease-in-out infinite'
        }} data-id="element-268" />
          <h1 className="font-serif text-[26px] sm:text-4xl md:text-5xl leading-[1.2] font-black max-w-4xl relative z-10 pt-[30px] pb-[30px]" data-id="element-269">
            No siempre vemos aquello{' '}
            <span className="text-gold" data-id="element-270">
              que más influye en nosotros.
            </span>
          </h1>
        </div>

        <div className="text-sm sm:text-lg opacity-90 leading-relaxed mb-6 sm:mb-8 max-w-2xl mx-auto font-medium px-2 sm:px-0 relative z-10" data-id="element-271">
          <p data-id="element-272">
            Código 888 es una experiencia digital privada que reúne lecturas,
            archivos complementarios y audios inmersivos diseñados para ayudarte
            a observar con más claridad los pensamientos, patrones y
            distracciones que normalmente pasan desapercibidos.
          </p>
        </div>

        {/* Mini bullets */}
        <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-2 sm:gap-y-3 text-left mb-8 sm:mb-12 max-w-2xl mx-auto relative z-10 px-2 sm:px-0" data-id="element-273">
          {['Biblioteca privada de experiencias y lecturas', 'Archivos complementarios de reflexión personal', 'Audios inmersivos para momentos de observación y enfoque', 'Acceso inmediato desde cualquier dispositivol'].map(item => <li key={item} className="flex items-start gap-2.5 text-white/85 text-xs sm:text-sm font-medium" data-id="element-274">
              <span className="shrink-0 mt-0.5 flex items-center justify-center w-4 h-4 rounded-full bg-gold/15 text-gold" data-id="element-275">
                <svg width="10" height="10" viewBox="0 0 12 12" fill="none" aria-hidden="true" data-id="element-276">
                  <path d="M2.5 6.5L5 9L9.5 3.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-277" />
                </svg>
              </span>
              <span data-id="element-278">{item}</span>
            </li>)}
        </ul>

        <div className="flex flex-col items-center w-full relative z-10" data-id="element-279">
          <button onClick={() => {
          document.getElementById('comparacion')?.scrollIntoView({
            behavior: 'smooth'
          });
        }} className="bg-gold text-dark min-h-[48px] py-3.5 sm:py-4 px-6 sm:px-12 text-sm sm:text-lg font-black rounded-xl shadow-[0_15px_40px_rgba(212,175,55,0.35)] hover:shadow-[0_20px_50px_rgba(212,175,55,0.5)] hover:bg-yellow-400 active:scale-[0.97] transition-all duration-300 w-full max-w-[300px] sm:max-w-md" data-id="element-280">
            COMENZAR EXPERIENCIA
          </button>

          <p className="text-white/60 text-xs sm:text-sm mt-5 sm:mt-6 tracking-wide" data-id="element-281">
            💳 Pago único · ⚡ Acceso inmediato · 🔓 Sin suscripciones
          </p>
        </div>
      </div>
    </section>;
}